import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import {} from "font-awesome-6";
import { markup } from "@/components/ObjectStore/configurationMarkdown";
import Heading from "@/components/Common/Heading.vue";
import TextSummary from "@/components/Common/TextSummary.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SourceOptionCard',
    props: {
        sourceOption: null,
        selectRoute: null,
        optionType: null,
        gridView: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        function markdownToHTML(text) {
            return markup(text ?? "", true);
        }
        return { __sfc: true, props, markdownToHTML, FontAwesomeIcon, BButton, Heading, TextSummary };
    }
});
